import "../../../tailwind/css/fonts.css";
import "@hst-elements/hst_button/src/bootstrapper.css";

export const itemConfigs = [
    {
        nodeName: 'hst-button',
        shouldImport: true,
        // @ts-ignore
        asyncImport: () => import('@hst-elements/hst_button/dist/')
    },
    {
        nodeName: 'hst-admin-link',
        shouldImport: true,
        // @ts-ignore
        asyncImport: () => import('@hst-elements/hst_admin_link/dist/')
    },
    {
        nodeName: 'hst-promotional-banner',
        shouldImport: true,
        // @ts-ignore
        asyncImport: () => import('@hst-components/hst_promotional_banner/dist/')
    },
    {
        nodeName: 'hst-notification-banner',
        shouldImport: true,
        // @ts-ignore
        asyncImport: () => import('@hst-components/hst_notification_banner/dist/')
    },
    {
        nodeName: 'hst-badge',
        shouldImport: true,
        // @ts-ignore
        asyncImport: () => import('@hst-elements/hst_badge/dist/')
    },
];